import React, { Component } from 'react';
import * as signalR from "@microsoft/signalr"
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { GoodsPhoto, ComPhoto } from "../../../js/ComponentManager";
import { LiveChatOrderPaper } from "./LiveChatOrderPaper";

/* 개발담당:양유빈
 * 화면기능:라이브챗팅 대화상자
 * 세부설명:
*/

export class LiveChatDig extends Component {
    static displayName = LiveChatDig.name;

    constructor(props) {
        super(props);
        this.state = {
            ReadCount: 0,    //읽음 기준값
            Message: "",
            RetailInfo:"",
            MessageType: Big3Common.WebConfig.LiveChatMsgType.Text,
            ChatData: []
        };
         
        this.LiveChatOrderPaperRef = React.createRef();

        this.CsName = Big3Common.ContentState;
        this.Uid = ""; //도매 UID
        this.Union_Uid = "";
        this.Goods_No = 0;
        this.Ordgrp_No = 0;
        if (this.props.ContentState !== undefined) {
            this.Union_Uid = this.props.ContentState[this.CsName.Union_Uid] !== undefined ? this.props.ContentState[this.CsName.Union_Uid] : "";
            this.Goods_No = this.props.ContentState.SelectGoods_No !== undefined ? this.props.ContentState.SelectGoods_No : 0;
            this.Ordgrp_No = this.props.ContentState.SelectOrdgrp_No !== undefined ? this.props.ContentState.SelectOrdgrp_No : 0;
        }

        this.handleSendMessage_Click = this.handleSendMessage_Click.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.handle_KeyDown = this.handle_KeyDown.bind(this);

        this.JoingroupName = "";
        this.ChatHubUrl = "";
        this.Connection = null;
        this.Secure_Token = "";
        this.isReceive = false;     //채널그룹 Connection이 다중으로 연결 될때 중북 Receive를 제한하기 위한 플래그
        this.WillUnmount = true;    //채널 카운팅을 설정(감소)하기 위한 플래그
    }
    //초기화
    async componentDidMount() {
        this.WillUnmount = true;
        await this.LiveChat.Init();
        if (this.Goods_No > 0) {
            this.LiveChat.SendMessageMake(this.Goods_No, Big3Common.WebConfig.LiveChatMsgType.Goods);
            this.props.ContentState.SelectGoods_No = 0;
        }
        if (this.Ordgrp_No > 0) {
            this.LiveChat.SendMessageMake(this.Ordgrp_No, Big3Common.WebConfig.LiveChatMsgType.Order);
            this.props.ContentState.SelectOrdgrp_No = 0;
        }
    }
    componentWillUnmount() {
        if (this.WillUnmount === true) {
            this.LiveChat.LeaveGroup(this.JoingroupName, this.Secure_Token, this.Union_Uid);
        }
    } 
    LiveChat = {
        Init: async () => {
            //채팅 초기화
            try {
                Big3Common.Util.LoadingOn();
                let Data = await Big3Common.Post('api/Order/LiveChat/GetLiveChatInit',
                    { union_uid: this.Union_Uid });
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    const ChatInfo = JSON.parse(Data.multiDataTable);                    
                    this.ChatHubUrl = ChatInfo.ChatHubUrl;
                    this.JoingroupName = ChatInfo.GroupName;
                    this.Secure_Token = ChatInfo.Secure_Token;
                    this.Uid = ChatInfo.Uid;
                    const ChatData = ChatInfo.ConverSation;
                    const RetailInfo = ChatInfo.RetailInfo[0];
                    this.setState({ ChatData: ChatData, ReadCount: ChatData.length, RetailInfo: RetailInfo });

                    if (this.ChatHubUrl !== "" && this.JoingroupName !== "") {
                        this.Connection = new signalR.HubConnectionBuilder()
                            .withUrl(this.ChatHubUrl)
                            .build();
                        try {
                            await this.Connection.start();
                            await this.LiveChat.joinGroup(this.JoingroupName, this.Secure_Token, this.Uid);
                            this.Connection.on("ReceiveMessage", (jsonData) => {
                                console.log(jsonData);
                                if (jsonData.resultCode === "Success" && this.isReceive === false) {
                                    this.isReceive = true;
                                    this.LiveChat.GetLiveChatTop1(jsonData);
                                }
                            });
                        } catch (e) {
                            console.log("Connection Error", e.toString());
                        }
                    }
                }
                else {
                    alert("채팅 서비스를 연결할 수 없습니다.\n 창을닫고 다시 연결하여주세요.");
                }
            }
            catch (e) {
                console.log("LiveChatInit", e.toString());
            }
            finally {
                window.scrollTo(0, document.body.scrollHeight, 'instant');
                Big3Common.Util.LoadingOff();
            }
            return false;
        },
        joinGroup: async (groupName, secure_token, userID) => {
            //Chat 그룹조인
            try {
                await this.Connection.invoke("JoinGroup", groupName, secure_token, userID);
            } catch (e) {
                console.log("JoinGroup Error", e.toString());
            }
        },
        LeaveGroup: async (groupName, secure_token, userID) => {
            //Chat 나가기
            try {
                await this.Connection.invoke("LeaveGroup", groupName, secure_token, userID);
            } catch (e) {
                console.log("JoinGroup Error", e.toString());
            }
        },
        SendMessageMake: async (message, messagetype) => {
            if (message === 0 || message === "") {
                return false;
            }
            let jsonMsg = {
                Message: message,
                MessageType: messagetype,
                Secure_Token: this.Secure_Token,
                GroupName: this.JoingroupName,
                User_Idx: "WH",  //마스터코드(019)
            }
            let jsonMsgString = JSON.stringify(jsonMsg);
            this.LiveChat.SendToHubInvoke(jsonMsgString);
        },
        SendToHubInvoke: async (jsonMsgString) => {
            //메세지 전송
            if (this.Connection.state.toString() === "Connected") {
                this.Connection.invoke("SendMessageToGroup", this.JoingroupName, this.Uid, jsonMsgString).catch(function (err) {
                    return console.error(err.toString());
                });
            }
            else {
                console.log("web socket 닫힘");
            }
        },
        GetLiveChatTop1: async () => {
            //마지막 Chat 내용가져오기(1개)
            try {

                let Data = await Big3Common.Post("api/Order/LiveChat/GetLiveChatTop1",
                    {
                        Uid: this.Uid,
                        Union_Uid: this.Union_Uid
                    },
                    true);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let DataList = JSON.parse(Data.multiDataTable);
                    const ConverSation = DataList.ConverSation;
                    if (ConverSation.length > 0) {
                        let ChatDataPush = this.state.ChatData;
                        ConverSation.map(list => ChatDataPush.push(list));
                        const ConfYnData = DataList.ConfYnData;
                        if (ConfYnData.length === 0) {
                            //"N"인것 전체를 "Y"로 업데이트
                            ChatDataPush.filter(list => list.conf_yn === "N").map(list => list.conf_yn = "Y");
                        }
                        else {
                            //"N"인 값들만 가져온 후
                            ConfYnData.map(list => function () {
                                //"N" chat_no는 그데로 두고, "N" 이면서 chat_no가 다른 conf_yn만 "Y"로 변경
                                ChatDataPush.filter(list2 => list2.chat_no !== list.chat_no && list2.conf_yn === "N").map(list3 => list3.conf_yn = "Y");
                            })

                        }
                        this.setState({
                            ChatData: ChatDataPush
                        });
                    }
                }
                else {
                    console.log(Data.message);
                }
            }
            catch (e) {
                console.log("CallGoodsData: ", e)
            }
            finally {
                this.isReceive = false;
                window.scrollTo(0, document.body.scrollHeight, 'instant');
            }

            return false;
        }
    }
    handleChange = (event) => {
        let value = event.target.value;
        this.setState({
            Message: value
        });
        event.preventDefault();
    }
    handleBlur = (event) => {
        let value = event.target.value;
        this.setState({
            Message: value
        });
        event.preventDefault();
    }
    handle_KeyDown = (event) => {
        if (event.key === "Enter") {
            this.handleSendMessage_Click(event);
            event.preventDefault();
        }
    }
    //Text 메세지 전송
    handleSendMessage_Click = (event) => {
        const Message = this.state.Message;
        if (Message === "") return false;
        this.LiveChat.SendMessageMake(Message, Big3Common.WebConfig.LiveChatMsgType.Text);
        this.setState({ Message: "" });
        event.preventDefault();
    }
    //주문 상세보기
    handleOrderDtl_Click(event, list) {
        this.LiveChatOrderPaperRef.current.CallOrdMgtMstDtlRef(list.union_uid, list.ordgrp_no);
        Big3Common.ModalAlert(bootstrap, "LiveChatOrderPaper");
        event.preventDefault();
    }
    //상품선택,주문석택 이동
    handleMove_Click = (event, CompName) => {
        this.WillUnmount = false;
        const ContentState = this.props.ContentState;
        ContentState[this.CsName.Union_Uid] = this.Union_Uid;
        this.props.RenderComponent(CompName, ContentState);
        event.preventDefault();
    }
    //상품상세보기
    async handleGoodsDtl_Click(event, goods_no) {
        this.WillUnmount = false;
        const ContentState = this.props.ContentState;
        ContentState[this.CsName.Union_Uid] = this.Union_Uid;
        ContentState[this.CsName.Goods_No] = goods_no;
        this.props.RenderComponent("GoodsDtl", ContentState);
        event.preventDefault();
    }
   
    DialogueBoxrender(list) {
        if (list.contt !== null && list.contt !== "") {
            //단순 Text Chat
            return (
                <div className="Conversation_box">
                    {list.user_idx === "RE" ?
                        <>
                            <div className="Conversation">{list.contt}</div><div className="chat_time">{list.reg_hour}</div>
                        </>
                        :
                        <>
                            <div className={list.user_idx === "WH" && list.conf_yn === "N" ? "chat_check" : "chat_check item_hide"}>1</div>
                            <div className="chat_time">{list.reg_hour}</div><div className="Conversation">{list.contt}</div>
                        </>
                    }                    
                </div>
            )
        }
        else if (list.ordgrp_no !== null && list.ordgrp_no !== "") {
            //주문서 Chat
            return (
                <div className="chat_goods_box_wrap">
                    <div className="chat_goods_box">
                        <div className="chat_order_date">{list.ord_dt} 주문</div>
                        <div className="goods_info_box">
                            <GoodsPhoto
                                className="goods_img"
                                ImageSrc={list.order_goods_img100}
                            />
                            <div className="goods_info_txt_box">
                                <div className="goods_name">{list.ord_goods_nm || ""}</div>
                                <div className="goods_price">{Big3Common.Util.Money(list.order_tot_price || 0)}원</div>
                                {list.soldout_yn === "Y" ?
                                    <div className="sold_out">품절</div>
                                    :
                                    <div className={list.ord_status === "JM" ? "order_status_p" : "order_status_f"}>{list.ord_status_nm}</div>
                                }
                            </div>
                        </div>
                        <div className="goods_btn_box">
                            <div className="view_btn2" onClick={(e) => { this.handleOrderDtl_Click(e, list) }}>상세보기</div>
                        </div>
                        <div className="chat_order_type">{list.ord_use_nm}</div>
                    </div>
                </div>
            )
        }
        else if (list.goods_no !== null && list.goods_no !== "") {
            //상품문의 Chat
            return (
                <div className="chat_goods_box_wrap">
                    <div className="chat_goods_box">
                        <div className="goods_info_box">
                            <GoodsPhoto
                                className="goods_img"
                                ImageSrc={list.img_100}
                            />
                            <div className="goods_info_txt_box">
                                <div className="goods_name">{list.goods_nm}</div>
                                <div className="goods_price"> {list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                {list.use_yn === "Y" ? "" : <div className="delete_txt">삭제된 상품입니다.</div>}
                                {list.soldout_yn === "Y" ? <div className="c_sold_out">품절</div> : ""}
                            </div>
                        </div>
                        {list.use_yn === "N" ? "" :
                            <div className="goods_btn_box" onClick={(e) => { this.handleGoodsDtl_Click(e,list.goods_no) }}>
                                <div className="view_btn2">상세보기</div>
                            </div>
                        }
                    </div>
                </div>
            )
        }
    }
    Conversation() {
        const ChatData = this.state.ChatData;
        if (ChatData.length === 0) return;

        const ChatDataDayName = Big3Common.Util.groupBy(ChatData, list => list.day_name);
        let ChatDataGroup = [];
        for (const item of ChatDataDayName.entries()) {
            ChatDataGroup.push({ "DateName": item[0], "DtlList": item[1] });
        }
        //읽음처리 증가변수
        let _ReadCount = 0;
        return (
            <>
                {
                    ChatDataGroup.map((list, idx) =>
                        <div key={idx}>
                            <div className="chat_date">{list.DateName}</div>
                            {
                                list.DtlList.map((subList) =>
                                    <div key={subList.chat_no} className={subList.user_idx === 'RE' ? "chatbox_left" : "chatbox_right"} >
                                        {this.DialogueBoxrender(subList)}
                                        {AddCount() === this.state.ReadCount ? <div className="read_check">- 여기까지 읽음 -</div> : ""}
                                    </div>
                                )
                            }
                        </div>

                    )}
            </>
        )
        function AddCount() {
            _ReadCount++;
            return _ReadCount;
        }
    }
    render() {
        const Conversation = this.Conversation();
        const RetailInfo = this.state.RetailInfo;
        if (document.querySelector(".page_title") !== null) {
            document.querySelector(".page_title").innerHTML = RetailInfo.retail_org_name || "";
        }
        return (
            <div>
                <div className="chating_info_box">
                    <ComPhoto
                        className="c_shop_img"
                        Photo={RetailInfo.retail_photo}
                    />
                    <div className="c_shop_info">
                        <div className="c_shop_add">[{RetailInfo.retail_area_nm || ""}] {RetailInfo.retail_addr_1}</div>
                    </div>

                    <div className="ch_products" onClick={(e) => { this.handleMove_Click(e, 'LiveChatGoods'); }}>
                        <div className="icon"></div>
                        <div className="title">상품선택</div>
                    </div>
                    <div className="ch_order" onClick={(e) => { this.handleMove_Click(e, 'LiveChatOrder'); }}>
                        <div className="icon"></div>
                        <div className="title">주문선택</div>
                    </div>
                </div>
                <div className="p_g_margin container_box d_padding">
                    <div className="chating_box">
                        {Conversation }
                    </div>
                </div>
                <div className="chat_input_box2">
                    <div className="chat_input_box_in">
                        <div className="cs_btn" onClick={() => { this.LiveChat.Init(); }}></div>
                        <input type="text" className="chat_type_input"
                            maxLength="100"
                            placeholder="문의하실 내용을 입력해주세요."
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            value={this.state.Message}
                            onKeyDown={this.handle_KeyDown}
                        />
                        <div className="photo_btn item_hide"></div>
                        <div className={this.state.Message === "" ? "send_btn" : "send_btn send_on"}
                            id="btnSendMessage"
                            onClick={(e) => { this.handleSendMessage_Click(e) }}
                        />
                    </div>
                </div>
                <LiveChatOrderPaper
                    id="LiveChatOrderPaper"
                    ref={this.LiveChatOrderPaperRef }
                />
            </div>
        );
    }
}
